import { useTranslation } from 'react-i18next';

import type { ConnectionState } from '../schemas/channel-state';

import { StepBadge } from './channel-step';

/** Connected, Not connected, or the reason the connection needs a person. */
export function NetworkStatusBadge({ state }: { state: ConnectionState }) {
  const { t } = useTranslation('social');
  if (state === 'connected') return <StepBadge tone="done">{t('status.connected')}</StepBadge>;
  if (state === 'disconnected') {
    return <StepBadge tone="todo">{t('status.disconnected')}</StepBadge>;
  }
  return <StepBadge tone="attention">{t(`status.${state}`)}</StepBadge>;
}
